import type { MessageDescriptor } from 'react-intl';

export const recommendationTypeEnableRefundAssist = 'EnableRefundAssist';

export type RecommendationMessages = {
  title: MessageDescriptor;
  description: MessageDescriptor;
  buttonLabel: MessageDescriptor;
  [key: string]: MessageDescriptor;
};

export const DISMISSAL_STORAGE_KEYS = {
  REFUND_ASSIST: 'seller-recommendation-refund-assist-dismissed',
} as const;
